import { render, staticRenderFns } from "./link-new-agent.vue?vue&type=template&id=492ae608&scoped=true&"
import script from "./link-new-agent.vue?vue&type=script&lang=ts&"
export * from "./link-new-agent.vue?vue&type=script&lang=ts&"
import style0 from "./link-new-agent.vue?vue&type=style&index=0&id=492ae608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ae608",
  null
  
)

export default component.exports